import { render, staticRenderFns } from "./WatCapacitationsTopics.vue?vue&type=template&id=151e86fb&"
import script from "./WatCapacitationsTopics.vue?vue&type=script&lang=js&"
export * from "./WatCapacitationsTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports